import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/modal';
import '../scss/main.scss';
const window = global.window;
import './plugins.js';
import './_main.js';
